import {
    fetchDecorationTypes,
    fetchDecorations,
    postDecoration
} from "../data/apiClient";

import {
    getDecorationTypeMappedList
} from "./decorationTypeMapper";

export const decorationRepository = {
    getDecorationTypes: async () => {
        const response = await fetchDecorationTypes();
        const typesDtoList = response.data;
        return getDecorationTypeMappedList(typesDtoList);
    },

    getDecorations: async (typeId, page) => {
        const response = await fetchDecorations(typeId, page);
        const result = response.data;
        return result
    },

    postDecoration: async (formBody) => {
        try {
            const response = await postDecoration(formBody);
            return { success: response.status === 200 };
        } catch (error) {
            return { success: false, message: 'Something went wrong' };
        }
    }

};